<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>

<template>
    <VRow
        v-bind="$attrs"
        class="b-row"
    >
        <slot />
    </VRow>
</template>
